export const REPORT_VIEW = "REPORT_VIEW";
export const PLAYBACK_VIEW = "PLAYBACK_VIEW";
export const MAP_REPORT_DEFAULT = "MAP_REPORT_DEFAULT";
export const MAP_REPORT_VERTICAL_SPLIT = "MAP_REPORT_VERT_SPLIT";
export const MAP_REPORT_HORIZONTAL_SPLIT = "MAP_REPORT_HORIZONTAL_SPLIT";
export const MAP_REPORT_VERTICAL_REVERSE_SPLIT = "MAP_REPORT_VERTICAL_REVERSE_SPLIT";
export const MAP_REPORT_HORIZONTAL_REVERSE_SPLIT = "MAP_REPORT_HORIZONTAL_REVERSE_SPLIT";
export const MAP_VIEW = "MAP_VIEW";
export const MAP_FULL_SCREEN = "MAP_FULL_SCREEN";
export const MAP_ABOVE_REPORT_HORIZONTAL = "MAP_ABOVE_REPORT_HORIZONTAL"